import React from 'react';
import styles from '../styles/CheckoutReturn.module.css';

/**
 * Full-screen confirmation shown right after a coaching session is booked —
 * the sibling of CoachingCheckoutReturn ("Payment received"), sharing its
 * stylesheet and shape so purchase → booking reads as one flow.
 *
 * It overlays the session details screen (already navigated to underneath),
 * so the CTA just dismisses it.
 *
 * Props:
 * - session: the booked session ({ scheduled_start, coach }); null renders nothing
 * - onDone: called by the CTA — dismiss and reveal the session details
 */
function BookingConfirmed({ session, onDone }) {
  if (!session?.scheduled_start) return null;

  const start = new Date(session.scheduled_start);
  const day = start.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  const time = start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  const coachName = session.coach?.displayName;

  return (
    <div className={styles.screen} role="dialog" aria-modal="true" aria-labelledby="booking-confirmed-title">
      <div className={styles.inner}>
        <div className={styles.eyebrow}>Sophia</div>
        <h1 id="booking-confirmed-title" className={styles.title}>Your session is booked</h1>
        <p className={styles.text}>
          {coachName ? `You're meeting ${coachName} on` : `We'll see you on`}
          <br />
          <strong className={styles.highlight}>{day} at {time}</strong>
          <br />
          We&rsquo;ve emailed you the details and a calendar invite.
        </p>
        <button className={styles.button} onClick={onDone} autoFocus>
          View session details
        </button>
      </div>
    </div>
  );
}

export default BookingConfirmed;
